(function () {
  "use strict";

  var isRendered = function (element) {
    return element.getClientRects().length > 0 && getComputedStyle(element).visibility !== "hidden";
  };

  var hydrateVideo = function (video) {
    if (!video || video.dataset.auVideoLoaded === "true" || !isRendered(video)) return false;
    var sources = video.querySelectorAll("source[data-src]");
    if (!sources.length) return false;
    sources.forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute("data-src");
    });
    video.dataset.auVideoLoaded = "true";
    video.load();
    return true;
  };

  var bindDeferredVideos = function (scope) {
    scope.querySelectorAll("video[data-au-video-deferred]").forEach(function (video) {
      if (video.dataset.auVideoBound === "true") return;
      video.dataset.auVideoBound = "true";
      var prepare = function () { hydrateVideo(video); };
      video.addEventListener("pointerdown", prepare, { passive: true });
      video.addEventListener("focus", prepare);
      video.addEventListener("keydown", prepare);
      var wrapper = video.closest(".product-video--root");
      if (wrapper) wrapper.addEventListener("pauseMedia", function () { video.pause(); });
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (video.hasAttribute("data-au-video-autoplay") && !reduce && "IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && isRendered(video)) {
              hydrateVideo(video);
              var playing = video.play();
              if (playing && playing.catch) playing.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { rootMargin: "200px 0px", threshold: 0.25 });
        observer.observe(video);
      } else if ("IntersectionObserver" in window) {
        var attach = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && hydrateVideo(video)) attach.disconnect();
          });
        }, { threshold: 0.25 });
        attach.observe(video);
      }
    });
  };

  var boot = function (scope) {
    bindDeferredVideos(scope);
    var root = scope.querySelector("[data-au-pdp-gallery]");
    if (!root || root.hasAttribute("data-au-pg-ready")) return;

    var track = root.querySelector("[data-au-pg-track]");
    var current = root.querySelector("[data-au-pg-current]");
    if (!track) return;

    var vids = track.querySelectorAll("video.au-media--video");
    if (vids.length) {
      var reduce =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduce) {
        vids.forEach(function (v) {
          v.removeAttribute("autoplay");
          v.pause();
        });
      } else if ("IntersectionObserver" in window) {
        var vio = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting && isRendered(root)) {
                hydrateVideo(en.target);
                en.target.muted = true;
                var p = en.target.play();
                if (p && p.catch) p.catch(function () {});
              } else {
                en.target.pause();
              }
            });
          },
          { root: track, threshold: 0.6 }
        );
        vids.forEach(function (v) {
          vio.observe(v);
        });
      }
    }

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    var warm = function (idx) {
      [idx, idx - 1, idx + 1].forEach(function (n) {
        var s = slides[n];
        if (!s) return;
        s.querySelectorAll("img[loading='lazy']").forEach(function (img) {
          img.loading = "eager";
        });
      });
    };

    var active = track.querySelector("[data-active='true']");
    if (active && active.offsetLeft > 0) {
      track.scrollTo({ left: active.offsetLeft });
    }
    warm(active ? slides.indexOf(active) : 0);

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              var idx = slides.indexOf(entries[i].target);
              if (current) current.textContent = idx + 1;
              warm(idx);
            }
          }
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (s) {
        io.observe(s);
      });
    }

    var page = function (dir) {
      track.scrollBy({ left: dir * track.clientWidth, behavior: "smooth" });
    };
    var prev = root.querySelector("[data-au-pg-prev]");
    var next = root.querySelector("[data-au-pg-next]");
    if (prev) prev.addEventListener("click", function () { page(-1); });
    if (next) next.addEventListener("click", function () { page(1); });

    var zoomButton = root.querySelector("[data-au-pg-zoom]");
    if (zoomButton) {
      zoomButton.hidden = !track.querySelector("img.au-media--image");
      zoomButton.addEventListener("click", function () {
        var slide = slides[Math.round(track.scrollLeft / track.clientWidth)] || slides[0];
        if (slide) zoom(track, slide);
      });
    }

    var edgeTicking = false;
    var edges = function () {
      edgeTicking = false;
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.setAttribute("aria-disabled", track.scrollLeft <= 2 ? "true" : "false");
      if (next) next.setAttribute("aria-disabled", track.scrollLeft >= max - 2 ? "true" : "false");
    };
    track.addEventListener(
      "scroll",
      function () {
        if (edgeTicking) return;
        edgeTicking = true;
        requestAnimationFrame(edges);
      },
      { passive: true }
    );
    edges();

    var lastVariantMediaId = null;
    var onVariant = function (e) {
      var media = e && e.detail && e.detail.variant && e.detail.variant.featured_media;
      if (!media || !media.id || media.id === lastVariantMediaId) return;
      lastVariantMediaId = media.id;
      var slide = track.querySelector("[data-media-id='" + media.id + "']");
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
    };
    var ev = root.dataset.variantEvent;
    if (ev) window.addEventListener(ev, onVariant);

    track.addEventListener("click", function (e) {
      var img = e.target.closest && e.target.closest("img.au-media--image");
      if (img) zoom(track, img);
      var video = e.target.closest && e.target.closest("video.au-media--video");
      if (video && video.muted && !video.paused) video.muted = false;
    });

    root.setAttribute("data-au-pg-ready", "");
  };

  var zoom = function (track, tapped) {
    var slide = tapped.closest("[data-media-id]");
    track.dispatchEvent(new CustomEvent("au:zoom", { bubbles: true, detail: { mediaId: slide && slide.getAttribute("data-media-id") } }));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) { boot(event.target); });
})();
